<footer id="footer-section">
    <div class="container">
        <div class="row">

            <div class="col-3">
                <p class="list-title">Site Navigation</p>
                <ul>
                    <li>Home</li>
                    <li>Solutions</li>
                    <li>Services</li>
                    <li>Pricing</li>
                    <li>Resources</li>
                    <li>Company</li>
                </ul>
            </div>

            <div class="col-3">
                <p class="list-title">PI | Account</p>
                <ul>
                    <li>
                        <a [href]="environment.portalLinks.login">Launch PI | Portal</a>
                    </li>
                    <li>Manage Account Data</li>
                    <li>Request Account Credentials</li>
                </ul>
            </div>

            <div class="col-3">
                <p class="list-title">PI | Products & Services</p>
                <ul>
                    <li>Software Development</li>
                    <li>Accounting</li>
                    <li>CRM</li>
                    <li>Hardware Rental</li>
                    <li>Information Technology</li>
                </ul>
            </div>

            <div class="col-3">
                <p class="list-title">Legal</p>
                <ul>
                    <li>
                        <a [routerLink]="['terms-of-service']">Terms of Service</a>
                    </li>
                    <li>
                        <a [routerLink]="['privacy-policy']">Privacy Policy</a>
                    </li>
                    <li>Licensing</li>
                    <li>Permits</li>
                </ul>
            </div>

            <div class="col-3">
                <p class="list-title">Company</p>
                <ul>
                    <li>Careers</li>
                    <li>Culture</li>
                    <li>Mission & Values</li>
                </ul>
            </div>

            <div class="col-3">
                <p class="list-title">Partners & Organizations</p>
                <ul>
                    <li>PowellTech</li>
                    <li>SMA Resource Technology</li>
                    <li>Girls Who Code</li>
                </ul>
            </div>

            <div class="col-3">
                <p class="list-title">Investors</p>
                <ul>
                    <li>Earnings Reports</li>
                    <li>Dividends</li>
                    <li>Press</li>
                    <li>Change Logs</li>
                    <li>Disaster Recovery</li>
                </ul>
            </div>

            <div class="col-3">
                <p class="list-title">College</p>
                <ul>
                    <li>PI | College Bridge</li>
                    <li>Scholarships</li>
                    <li>PI | Startup Program</li>
                    <li>Internships</li>
                </ul>
            </div>
        </div>

        <div class="row">
            <div class="container">
                <div class="col d-flex" id="cta-column">
                    <p class="text-white mb-0">Powell Industries is proud to deliver a cookie-free site.</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="container">
                <div class="col-lg-12">
                    <div class="horizontal-decorator-line-secondary my-3"></div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="container">
                <div class="col-lg-12 text-secondary" id="footer-bottom">
                    <p class="mb-0">© {{ dayjs().year() }} Powell Industries Inc. All Rights Reserved.</p>
                    <p class="mb-0"><fa-icon [icon]="faEarthAmerica" class="me-1"></fa-icon>United States of America (English)</p>
                </div>
            </div>
        </div>
    </div>
</footer>